import { render } from "./FlightPoliciesView.vue?vue&type=template&id=4162102c"
import script from "./FlightPoliciesView.vue?vue&type=script&lang=js"
export * from "./FlightPoliciesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__